/** Свойство строки корзины (ApiClient.basket.getBasket). */
export type CartProp = {
  CODE: string;
  NAME: string;
  VALUE: string;
};

/** Строка корзины (ApiClient.basket.getBasket). */
export type BasketApiItem = {
  ID: number;
  PRODUCT_ID: number;
  NAME?: string;
  PRICE: number;
  NO_DELIVERY_PRICE?: number;
  DELIVERY_PRICE?: number;
  PRICE_TOTAL: number;
  NO_DISCOUNT_PRICE?: number;
  NO_DISCOUNT_PRICE_TOTAL?: number;
  DISCOUNT_PRICE?: number;
  DISCOUNT_PRICE_TOTAL?: number;
  QUANTITY: number;
  URL?: string;
  CART_PROPS?: CartProp[];
  SECTION_ID?: number;
  BRAND_ID?: number;
  ELECTRIC?: string;
  FILTER_URL?: string;
  PICTURE?: string;
  PICTURE_ID?: string | null;
  ARTICLE?: string;
  WEIGHT?: number;
  DIMENSIONS?: {
    HEIGHT?: number;
    LENGTH?: number;
    WIDTH?: number;
  };
  DELIVERY?: unknown;
};

/** Корзина (ApiClient.basket.getBasket). */
export type BasketApi = {
  QTY: number;
  PRICE: number;
  NO_DISCOUNT_PRICE?: number;
  DISCOUNT_PRICE?: number;
  COUPON?: string | null;
  ORDER_WEIGHT?: number;
  ITEMS: BasketApiItem[];
};

/** PRODUCT_DATA строки (ответ POST getCartProducts). */
export type CartProductData = {
  NAME?: string;
  URL?: string;
  PICTURE_ID?: string | null;
  SECTION_ID?: number;
  BRAND_ID?: number | string;
  ELECTRIC?: string;
  FILTER_URL?: string;
  ARTICLE?: string;
};

/** Строка корзины в сторе после loadBasketWithProducts. */
export type BasketItem = BasketApiItem & {
  PRODUCT_DATA: CartProductData | null;
};

/** Тело POST /catalogServer/getCartProducts. */
export type GetCartProductsRequest = {
  items: GetCartProductsItem[];
  reset?: boolean;
};

/** Запрос PRODUCT_DATA для одной строки корзины. */
export type GetCartProductsItem = {
  productId: number | string;
  cartProps: CartProp[];
};

/** Ответ POST getCartProducts — массив PRODUCT_DATA в порядке items. */
export type GetCartProductsResponse = Array<CartProductData | null>;

/** Товар из Api.sections.getProductById (для mapProductToCartFields). */
export type SectionsProductApi = {
  ID?: string | number;
  NAME?: string;
  DETAIL_PAGE_URL?: string;
  PHOTOS_NEW?: string[];
  IBLOCK_SECTION_ID?: string | number;
  PROIZVODITEL?: { ENUM_ID?: number; ID?: number | string };
  ELEKTRIKA_V_KOMPLEKTE?: { VALUE?: string } | string | null;
  ARTICLE?: { VALUE?: string } | string;
  MARKA?: { CODE_ALT?: string; CODE?: string };
  MODEL?: { CODE_ALT?: string; CODE?: string };
  KUZOV?: { CODE_ALT?: string; CODE?: string };
};

export type RedisHgetClient = {
  hget: (key: string, field: string) => Promise<string | null>;
};

export enum DeliveryTypes {
  pickup = "pickup",
  install = "install",
  courier = "courier",
  sdek = "sdek",
  edost = "edost",
  edostCourier = "edostCourier",
}

export enum UserFields {
  name = "NAME",
  address = "ADR",
  phone = "PHONE",
  email = "EMAIL",
  location = "LOC",
  passport = "PASSPORT",
  pointId = "POINT_ID",
  pointInfo = "POINT_INFO",
  isNeedInstall = "IS_NEED_INSTALL",
  installTime = "INSTALL_TIME",
  deliveryTime = "TK_TIME_DELIVERY",
  deliveryPrice = "TK_PRICE_DELIVERY",
  deliveryPriceWithoutDiscount = "deliveryPriceWithoutDiscount",
  deliveryOldPrice = "TK_PRICE_OLD_DELIVERY",
  deliveryDays = "DELIVERY_DAYS",
  deliveryId = "DELIVERY_ID",
  tariffType = "TARIFF_TYPE",
  paySystemId = "PAY_SYSTEM_ID",
  total = "TOTAL",
  city = "CITY",
}
